module.exports = __webpack_public_path__ + "img/IMG_6638-Edit.0b5f9963.jpg";